import React from "react";
import {
  carwashApi_getTransactions,
  IReturnGetMembeship,
} from "../../../carwashApi";
import { useQuery } from "react-query";
import { DateTime } from "luxon";

export const MembershipUsageCount = (d: {
  membership: IReturnGetMembeship;
}) => {
  const trxQuery = useQuery(
    ["membership_count", d.membership],
    async () => {
      const trxData = await carwashApi_getTransactions({
        limit: 999999999,
        skip: 0,
        "transaction_items.transaction_item_name": "MEMBER CUCI",
        "memberships.membership_id": d.membership.membership_id,
        transaction_date_min:
          DateTime.fromISO(d.membership.issue_date).toISO() || undefined,
      });
      return trxData.data;
    },
    { retry: false }
  );
  return <>{trxQuery.data?.count || 0}</>;
};
